module.exports = __webpack_public_path__ + "706450d7bba6374ca02fe167d86685cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/fontawesome-webfont.ttf?v=4.3.0
// module id = 1158
// module chunks = 0